module.exports = __webpack_public_path__ + "img/rou.625aca9e.svg";